import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { cantidad, fecha, personal },
} = checkout;

const validations = [
  Yup.object().shape({
    [fecha.name]: Yup.date().required(fecha.errorMsg),
    [cantidad.name]: Yup.number()
      .typeError("Debe introducir un número")
      .min(1, "El valor debe ser mayor o igual a 1")
      .required(cantidad.errorMsg),
    [personal.name]: Yup.string().required(personal.errorMsg),
  }),
];

export default validations;
